import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AddGroup, GroupClientDetail, GroupList, GroupUserDetail, HttpGroupResponse, HttpResponse, UserHttpService } from "../public-api";

@Injectable({
    providedIn: 'root'
})
export class GroupHttpService {

    constructor(
        private http: HttpClient,
        private userService: UserHttpService
    ) {}

    addGroup(body: AddGroup, isEdit: boolean = false): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('usr_customer_track_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('group_name', body.group_name ? body.group_name : "");
        formData.append('group_notes', body.group_notes ? body.group_notes : "");
        formData.append('client_check', body.client_check ? '1' : '');
        formData.append('individual_check', body.individual_check ? '1' : '');

        if(body.users_ids.length > 0 && body.individual_check) {
            body.users_ids.forEach((X, i) => {
                if(X.user_id) {
                    formData.append(`users_ids[${i}]`, X.user_id); 
                }
            });
        };

        if(body.client_ids.length > 0 && body.client_check) {
            body.client_ids.forEach((X, i) => {
                if(X.company_id) {
                    formData.append(`client_ids[${i}]`, X.company_id); 
                }
            });
        };
        
        if(isEdit) {
            formData.append('group_id', body.group_id ? body.group_id: "");
        }

        let url = isEdit ? 'groups/GroupUpdate' : 'groups/CreateGroup'
        
        return this.http.post<HttpResponse<any>>(url, formData);
    }


    getAllGroupsList(): Observable<HttpResponse<GroupList[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('usr_customer_track_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        return this.http.post<HttpResponse<GroupList[]>>('groups/groupList', formData);
    }

    getGroupDetail(id: string): Observable<HttpGroupResponse<GroupUserDetail[], GroupClientDetail[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('usr_customer_track_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('group_id', id);
        return this.http.post<HttpGroupResponse<GroupUserDetail[], GroupClientDetail[]>>('groups/GroupDetail', formData);
    }

    editGroup(id: string): Observable<HttpGroupResponse<GroupUserDetail[], GroupClientDetail[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('usr_customer_track_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('group_id', id);
        return this.http.post<HttpGroupResponse<GroupUserDetail[], GroupClientDetail[]>>('groups/GroupUpdate', formData);
    }

    deleteGroup(id: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('usr_customer_track_id', this.userService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('group_id', id);
        return this.http.post<HttpResponse<any>>('groups/GroupDelete', formData)
    }

    
}